import services from '@/services/ascentiaServiceIndex'

import { FLIGHT_PHASE_CONSTS as FP } from '../consts'

const state = {
  flightPhases: [],
}

const getters = {
  flightPhases: state => {
    return state.flightPhases
  },
}

const mutations = {
  [FP.UPDATE_FLIGHT_PHASES]: (state, data) => (state.flightPhases = data),
}

const actions = {
  async [FP.GET_FLIGHT_PHASES]({ commit }) {
    const response = await services.flightPhase.getData('flightPhaseData')
    commit(FP.UPDATE_FLIGHT_PHASES, response.data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
